"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FetchPublishedSitePagesById = exports.FetchPublishedSitePagesByIdActionTypes = exports.fetchPublishedSitePagesById = exports.FetchPublishedSitePages = exports.FetchPublishedSitePagesActionTypes = exports.fetchPublishedSitePages = exports.SitePagesActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _constants = require("./constants");

var SitePagesActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_PUBLISHED_SITE_PAGES: null,
  FETCH_PUBLISHED_SITE_PAGES_BY_ID: null
}, _constants.SITE_PAGES);
exports.SitePagesActionTypes = SitePagesActionTypes;
var fetchPublishedSitePages = (0, _fluxActions.createAction)(SitePagesActionTypes.FETCH_PUBLISHED_SITE_PAGES, (0, _actions.mapPayloadTo)('params'));
exports.fetchPublishedSitePages = fetchPublishedSitePages;
var FetchPublishedSitePagesActionTypes = (0, _actions.createRequestTypes)(SitePagesActionTypes.FETCH_PUBLISHED_SITE_PAGES);
exports.FetchPublishedSitePagesActionTypes = FetchPublishedSitePagesActionTypes;
var FetchPublishedSitePages = (0, _actions.createRequestActions)(FetchPublishedSitePagesActionTypes, {
  keys: ['params']
});
exports.FetchPublishedSitePages = FetchPublishedSitePages;
var fetchPublishedSitePagesById = (0, _fluxActions.createAction)(SitePagesActionTypes.FETCH_PUBLISHED_SITE_PAGES_BY_ID, (0, _actions.mapPayloadTo)('params'));
exports.fetchPublishedSitePagesById = fetchPublishedSitePagesById;
var FetchPublishedSitePagesByIdActionTypes = (0, _actions.createRequestTypes)(SitePagesActionTypes.FETCH_PUBLISHED_SITE_PAGES_BY_ID);
exports.FetchPublishedSitePagesByIdActionTypes = FetchPublishedSitePagesByIdActionTypes;
var FetchPublishedSitePagesById = (0, _actions.createRequestActions)(FetchPublishedSitePagesByIdActionTypes, {
  keys: ['params']
});
exports.FetchPublishedSitePagesById = FetchPublishedSitePagesById;